module.exports = __webpack_public_path__ + "4e8097be3fc75b257f5bf17b23bebc4e.png";